import React, { useEffect, useRef } from 'react';

export default function ScrollComponent() {
  const scrollRef = useRef();

  useEffect(() => {
    // This handles FF & Safari
    window.addEventListener('unload', (e) => {
      e.preventDefault();
      window.scrollTo(0, 0);
    });
    // This handles Chrome
    scrollRef.current.scrollIntoView();

    return () => {
      scrollRef.current.scrollIntoView();
    };
  }, []);

  return (
    <div ref={scrollRef} style={{ visibility: 'hidden', height: '0px' }}>
      ScrollComponent Placeholder
    </div>
  );
}
